export enum AppRouteEnum {
  AchRefundTable = '/reports/ach-refunds',
  Auth = '/auth',
  CancelPendings = '/reports/cancel-pendings',
  CancelRewrites = '/reports/cancel-rewrites',
  ConsumerEdit = '/consumers/:id/edit',
  ConsumerProfile = '/consumers/:id',
  ConsumerWrapUp = '/consumers/:id/wrap-up',
  Consumers = '/consumers',
  ConsumerVehicle = '/consumers/:id/vehicles/:id',
  ContractById = '/contracts/:id',
  ContractByNumber = '/contracts/by-number/:id',
  ContractFulfillmentHistory = '/contracts/:id/fulfillment-history',
  ContactConfirmation = '/contacts/confirmation',
  ContactLink = '/contacts/link',
  ContactPreview = '/contacts/preview',
  ContactSearchAuto = '/contacts/search/auto',
  ContactSearchMail = '/contacts/search/mail',
  ContactSearchMoxyCustomerNumber = '/contacts/search/moxy-customer-number',
  ContactWaiting = '/contacts/waiting',
  ContactWrapUp = '/contacts/:id/wrap-up',
  ContractsAdjustmentAdjustCoverage = '/contracts/:id/adjustment/adjust-coverage',
  ContractsAdjustmentAdditionalActions = '/contracts/:id/adjustment/additional-actions',
  ContractsAdjustmentConfirmAdjustment = '/contracts/:id/adjustment/confirm-adjustment',
  ContractsAdjustmentConfirmOdometer = '/contracts/:id/adjustment/confirm-odometer',
  ContractCollectDownPayment = '/contracts/:id/collect-down-payment/',
  ContractPayInFullOnSold = '/contracts/:id/pay-in-full/',
  ContractCollectExceptionPayment = '/contracts/:id/exception-payment/',
  ContractTransmittalEventsErrorReport = '/reports/contract-transmittal-events-errors',
  Dashboard = '/dashboard',
  DealLog = '/deal-log',
  DuplicateSaves = '/reports/duplicate-saves',
  Forbidden = '/forbidden',
  // Home = '/dashboard',
  KnowledgeBase = '/knowledge-base',
  NewQuote = '/quotes/new',
  Quotes = '/quotes',
  QuoteFlowContactInfo = '/quotes/:id/contact-info',
  QuoteFlowCoverageAvailability = '/quotes/:id/coverage-availability',
  QuoteFlowEntry = '/quotes/:id',
  QuoteFlowFinalize = '/quotes/:id/finalize',
  QuoteFlowMissingVehicleDetails = '/quotes/:id/missing-vehicle-details',
  QuoteFlowPaymentMethod = '/quotes/:id/payment-method',
  QuoteFlowPayments = '/quotes/:id/payments',
  QuoteFlowSecondHolder = '/quotes/:id/second-holder',
  QuoteFlowSelectPlan = '/quotes/:id/select-plan',
  QuoteFlowVehicleDetails = '/quotes/:id/vehicle-details',
  QuoteFlowVehicleModifications = '/quotes/:id/vehicle-modifications',
  QuoteFlowClosed = '/quotes/:id/closed',
  QuoteFlowSaleComplete = '/quotes/:id/sold',
  QuoteFlowWrapUp = '/quotes/:id/wrap-up',
  QuoteScratchpad = '/quote-scratchpad',
  SendQuote = '/quotes/:id/send-quote',
  QuoteFlowTransferCall = '/quotes/:id/transfer-call',
  QuoteFlowRecap = '/quotes/:id/recap',
  QuoteFlowEquityCalculation = '/quotes/:id/equity',
  QuoteFlowCompleteRewrite = '/quotes/:id/complete-rewrite',
  QuoteFlowConfirmRewrite = '/quotes/:id/confirm-rewrite',
  Settings = '/settings',
  Users = '/users',
  PhysicalChecks = '/reports/physical-checks',
  ProcessContractManualRefund = '/contracts/:id/process-ach-refunds',
  ProcessSalePendingManualRefund = '/sale-pending/:id/process-ach-refunds',
  Roles = '/roles',
  VehicleDetails = '/vehicles/:id',
  VehicleShops = '/vehicle-shops/:id',
  Waiting = '/contacts/waiting/:id',
  CancelFlat = '/contracts/:id/cancel/flat',
  RequestCancellation = '/contracts/:id/cancel/request-cancellation',
  CompleteCancellation = '/contracts/:id/cancel/complete-cancellation',
  ProRatedRefund = '/contracts/:id/cancel/pro-rated-refund',
  RemoveCancelPending = '/contracts/:id/cancel/remove-cancel-pending',
  CancelNonPay = '/contracts/:id/cancel/non-pay',
  TransferContractUploadTransferForm = '/contracts/:id/transfer/upload-transfer-form',
  TransferContractSelectCustomer = '/contracts/:id/transfer/select-customer',
  TransferContractCollectMissingInfo = '/contracts/:id/transfer/collect-missing-info',
  TransferContractAdditionalHolder = '/contracts/:id/transfer/additional-holder',
  TransferContractPayments = '/contracts/:id/transfer/payments',
  TransferOwnerships = '/reports/transfer-ownerships-eds',
  NonEdsTransferOwnerships = '/reports/transfer-ownerships-non-eds',
  RetentionDiscounts = '/reports/retention-discounts',
  ContractWrapUp = '/contracts/:id/wrap-up',
  AdditionalRefund = '/contracts/:id/additional-refund',
  FullRefundManagerApproval = '/contracts/:id/full-refund/manager-approval',
  FullRefundCreateRequest = '/contracts/:id/full-refund/create-refund',
  FullRefundApproveRefund = '/contracts/:id/cancel/approve-full-refund',
  FullRefundIssueRefund = '/contracts/:id/cancel/issue-full-refund',
  VinAudit = '/vin-audit',
  MissingDownPayment = '/reports/missing-down-payment',
  ProRatedRefundsReport = '/reports/pro-rated-refund',
  CollectionReporting = '/contracts/:id/collection-reporting',
}
